module.exports = __webpack_public_path__ + "static/media/passportToken.54bca55e.svg";